import { Checkbox } from '@radix-ui/themes';
import { Row } from '@tanstack/react-table';

interface TableSelectionCellProps<T extends object> {
    row: Row<T>;
}

export const TableSelectionCell = <T extends object>({
    row,
}: TableSelectionCellProps<T>) => (
    <Checkbox
        highContrast
        color='gray'
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        disabled={!row.getCanSelect()}
        aria-label={'Select row'}
        mt={'2px'}
    />
);
